import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";

import { RemoteAppointmentTypeEnum } from "@hermes/api-model-remote-appointment";
import {
    HTTP_JSON_CONTENT_TYPE_HEADER,
    SKIP_404_INTERCEPTOR,
} from "@hermes/utils-generic-constants";

import { Appointment } from "../models/remote-rendez-vous-appointment.model";

@Injectable({ providedIn: "root" })
export class AppointmentsService {
    #httpClient = inject(HttpClient);

    /**
     * Get appointments of the current user
     */
    public getAppointments(): Observable<Appointment[]> {
        return this.#httpClient
            .get<AppointmentDto[]>(
                "/api/appointment/frontoffice/appointment/get-appointments",
                {
                    headers: new HttpHeaders({
                        ...HTTP_JSON_CONTENT_TYPE_HEADER,
                    }),
                    context: new HttpContext().set(SKIP_404_INTERCEPTOR, true),
                },
            )
            .pipe(
                map((appointments): Appointment[] => {
                    return (
                        Array.isArray(appointments) ? appointments : []
                    ).map((appointment) => ({
                        ...appointment,
                        startDate: new Date(appointment.startDate),
                        endDate: new Date(appointment.endDate),
                        productTitle: appointment.productTitle ?? "",
                        productSku: appointment.productSku ?? "",
                        productImage: appointment.productImage ?? "",
                        videoSessionId: appointment.videoSessionId ?? "",
                    }));
                }),
            );
    }

    /**
     * Cancel remote rendez vous
     * @param id to cancel
     * @returns undefined
     */
    public cancelRemoteRendezVous(id: string): Observable<void> {
        return this.#httpClient.post<void>(
            "/api/appointment/frontoffice/appointment/cancel-remote-rendez-vous",
            {
                appointmentId: id,
            },
            {
                headers: new HttpHeaders({
                    ...HTTP_JSON_CONTENT_TYPE_HEADER,
                }),
                context: new HttpContext().set(SKIP_404_INTERCEPTOR, true),
            },
        );
    }
}

interface AppointmentDto {
    id: string;
    type: RemoteAppointmentTypeEnum;
    startDate: string;
    endDate: string;
    storeView: string;
    storeLanguage: string;
    productTitle?: string;
    productSku?: string;
    productImage?: string;
    cancelled: boolean;
    videoSessionId?: string;
}
